import { useEffect } from 'react';
import { useHistory } from './TypedRoute.tsx';

export function useScrollToTopOnMount() {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [history.location.pathname]);

  return null;
}
